module.exports = __webpack_public_path__ + "img/addfriend2.a2b3f1b5.png";